const MESSAGE = "Minimale waarde mag niet hoger zijn dan de maximale";

export default (value: string, row: any) => {
    return value && (parseInt(value) < row.question.maxValue) ? undefined : MESSAGE 
}
